import React from 'react';
import ReactDOM from 'react-dom';
import 'react-dates/initialize';

import './styles.css';

import App from './App';
import './i18n';

ReactDOM.render(<App />, document.getElementById('root'));
